<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [customBack]="'properties'"
      [title]="'Notifications'"
      [showDropdownMenu]="true"
      [dropdownMenu]="notificationCenterDropDownMenu" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (loaded) {
      <div>
        <form [formGroup]="filterForm" novalidate action="#" class="bills-form-filters form-filters">
          <tidy-select
            class="select-custom-input"
            [label]="'Type'"
            [items]="notificationTypes"
            [form]="filterForm.get('notification_type')"
            formControlName="notification_type"
            (optionChange)="changeNotificationType($event)"
            [icon]="'assets/svg/notifications.svg'" />
        </form>
      </div>
      <tidy-row>
        <form [formGroup]="searchForm" novalidate action="#">
          <tidy-search-input
            formControlName="search"
            [placeholder]="'Search'"
            [icon]="'assets/img/search-header.svg'" />
        </form>
      </tidy-row>
      <!--<tidy-row [align]="'center'">
      <tidy-text
        *ngIf="!showExamples"
        [body]="'Show Examples'"
        (action)="showExamples = true">
      </tidy-text>
      <tidy-text
        *ngIf="showExamples"
        [body]="'Hide Examples'"
        (action)="showExamples = false">
      </tidy-text>
    </tidy-row>-->
    @if (filteredNotifications.length === 0) {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'<i>No notifications yet</i>'" />
      </tidy-row>
    }
    @if (showExamples) {
      <tidy-row [align]="'center'">
        @if (!showKeys) {
          <tidy-text
            [body]="'Show Keys'"
            (action)="showKeys = true" />
        }
        @if (showKeys) {
          <tidy-text
            [body]="'Hide Keys'"
            (action)="showKeys = false" />
        }
      </tidy-row>
    }
    @if (showExamples) {
      @for (notification of examples; track notification) {
        <tidy-card>
          <tidy-row class="vertical-align-middle">
            <tidy-image
              [src]="notification?.icon"
              class="header-size" />
            <tidy-text [body]="'<b>' + notification?.email_template_subject + '</b>'" style="margin-right: 5px" />
            <tidy-text
              [smallHelper]="notification?.created_at | parseDateTime:'MMM d h:mma':'local'" />
          </tidy-row>
          @if (showKeys) {
            <tidy-row class="extra-top-padding">
              <tidy-text [smallHelper]="notification?.notification_key" />
            </tidy-row>
          }
        </tidy-card>
      }
    }
    @for (notification of filteredNotifications; track notification) {
      @if (notification?.title) {
        <tidy-card>
          <tidy-card-button (action)="goToNotificationPage(notification)" [hideArrow]="!hasNotificationAction(notification)" [style.cursor]="notification?.is_read ? null : 'pointer'">
            <tidy-row class="vertical-align-middle">
              <tidy-image
                [src]="notification?.icon"
                class="header-size" />
              @if (!notification?.is_read) {
                <tidy-text
                  class="notification-content"
                  [body]="'<b>' + notification?.title + (notification?.groupedMessagesArray?.length > 0 ? ' (+' + (notification?.groupedMessagesArray?.length | translate) + (' more)' | translate) : '') + '</b>'"
                  style="margin-right: 5px" />
              }
              @if (notification?.is_read) {
                <tidy-text
                  class="notification-content"
                  [body]="notification?.title + (notification?.groupedMessagesArray?.length > 0 ? ' (+' + (notification?.groupedMessagesArray?.length | translate) + (' more)' | translate) : '')"
                  style="margin-right: 5px" />
              }
              <tidy-text
                [smallHelper]="notification?.created_at | parseDateTime:'MMM d h:mma':'local'" />
            </tidy-row>
            @if (showKeys) {
              <tidy-row class="extra-top-padding">
                <tidy-text [smallHelper]="notification?.notification_key" />
              </tidy-row>
            }
          </tidy-card-button>
        </tidy-card>
      }
    }
    @if (filteredNotifications.length < totalNotifications) {
      <ion-infinite-scroll (ionInfinite)="loadMoreNotifications($event)">
        <ion-infinite-scroll-content
          loadingSpinner="bubbles"
          loadingText="Loading more notifications..." />
      </ion-infinite-scroll>
    }
  }

  @if (!loaded) {
    @for (i of [1,2,3,4,5,6,7,8,9,10]; track i) {
      <tidy-card>
        <div style="display: flex; align-items: center; margin-bottom: 5px">
          <ion-skeleton-text animated="true" style="width: 20px; height: 20px; border-radius: 6px; margin-right: 5px" />
          <ion-skeleton-text animated="true" style="width: 89%; height: 16px; border-radius: 6px;" />
        </div>
      </tidy-card>
      <tidy-card>
        <div style="display: flex; align-items: center; margin-bottom: 5px">
          <ion-skeleton-text animated="true" style="width: 20px; height: 20px; border-radius: 6px; margin-right: 5px" />
          <ion-skeleton-text animated="true" style="width: 70%; height: 16px; border-radius: 6px;" />
        </div>
      </tidy-card>
      <tidy-card>
        <div style="display: flex; align-items: center; margin-bottom: 5px">
          <ion-skeleton-text animated="true" style="width: 20px; height: 20px; border-radius: 6px; margin-right: 5px" />
          <ion-skeleton-text animated="true" style="width: 100%; height: 16px; border-radius: 6px;" />
        </div>
        <div style="display: flex; align-items: center;">
          <ion-skeleton-text animated="true" style="width: 34%; height: 16px; border-radius: 6px;" />
        </div>
      </tidy-card>
      <tidy-card>
        <div style="display: flex; align-items: center; margin-bottom: 5px">
          <ion-skeleton-text animated="true" style="width: 20px; height: 20px; border-radius: 6px; margin-right: 5px" />
          <ion-skeleton-text animated="true" style="width: 83%; height: 16px; border-radius: 6px;" />
        </div>
      </tidy-card>
      <tidy-card>
        <div style="display: flex; align-items: center; margin-bottom: 5px">
          <ion-skeleton-text animated="true" style="width: 20px; height: 20px; border-radius: 6px; margin-right: 5px" />
          <ion-skeleton-text animated="true" style="width: 100%; height: 16px; border-radius: 6px;" />
        </div>
        <div style="display: flex; align-items: center;">
          <ion-skeleton-text animated="true" style="width: 58%; height: 16px; border-radius: 6px;" />
        </div>
      </tidy-card>
      <tidy-card>
        <div style="display: flex; align-items: center; margin-bottom: 5px">
          <ion-skeleton-text animated="true" style="width: 20px; height: 20px; border-radius: 6px; margin-right: 5px" />
          <ion-skeleton-text animated="true" style="width: 63%; height: 16px; border-radius: 6px;" />
        </div>
      </tidy-card>
      <tidy-card>
        <div style="display: flex; align-items: center; margin-bottom: 5px">
          <ion-skeleton-text animated="true" style="width: 20px; height: 20px; border-radius: 6px; margin-right: 5px" />
          <ion-skeleton-text animated="true" style="width: 93%; height: 16px; border-radius: 6px;" />
        </div>
      </tidy-card>
      <tidy-card>
        <div style="display: flex; align-items: center; margin-bottom: 5px">
          <ion-skeleton-text animated="true" style="width: 20px; height: 20px; border-radius: 6px; margin-right: 5px" />
          <ion-skeleton-text animated="true" style="width: 56%; height: 16px; border-radius: 6px;" />
        </div>
      </tidy-card>
      <tidy-card>
        <div style="display: flex; align-items: center; margin-bottom: 5px">
          <ion-skeleton-text animated="true" style="width: 20px; height: 20px; border-radius: 6px; margin-right: 5px" />
          <ion-skeleton-text animated="true" style="width: 68%; height: 16px; border-radius: 6px;" />
        </div>
      </tidy-card>
    }
  }

</tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
